<template>
  <div class="main-content">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Accounts</li>
        <li class="breadcrumb-item">Roles</li>
        <li class="breadcrumb-item"><router-link :to="{name: 'accounts-roles'}">Records</router-link></li>
        <li class="breadcrumb-item active">New record</li>
      </ol>
    </div>
    <form
      v-if="$store.state.permissions.create.accounts_roles"
      action="/api/admin/accounts/roles/save"
      method="POST"
      @submit.prevent="createRecord()"
    >
      <div class="card">
        <div class="card-header">
          <h3 class="page-title">Create new role</h3>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="form-group">
            <label>Name</label>
            <input
              :class="{ 'is-invalid': $v.record.name.$error }"
              v-model.trim="record.name"
              class="form-control"
              @input="$v.record.name.$touch()"
            >
            <div v-if="$v.record.name.$error">
              <span
                v-if="!$v.record.name.required"
                class="help-block help-block-error"
              >Field is required</span>
              <span
                v-if="!$v.record.name.minLength"
                class="help-block help-block-error"
              >Title must have at least {{ $v.record.name.$params.minLength.min }} letters.</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <h5>Permissions</h5>
        </div>
        <div class="card-body">
          <table-component ref="permissions" :show-filter="false" :data="record.matrix && Object.values(record.matrix) || []" sort-by="name" sort-order="asc" table-class="table">
            <table-column show="name" label="Name"/>
            <table-column
              :sortable="false"
              :filterable="false"
              label="See"
            >
              <template slot-scope="row">
                <input v-if="Object.keys(row).indexOf('see') !== -1" v-model="row.see" type="checkbox" >
              </template>
            </table-column>
            <table-column
              :sortable="false"
              :filterable="false"
              label="Create"
            >
              <template slot-scope="row">
                <input v-if="Object.keys(row).indexOf('create') !== -1" v-model="row.create" type="checkbox" >
              </template>
            </table-column>
            <table-column
              :sortable="false"
              :filterable="false"
              label="Edit"
            >
              <template slot-scope="row">
                <input v-if="Object.keys(row).indexOf('edit') !== -1" v-model="row.edit" type="checkbox" >
              </template>
            </table-column>
            <table-column
              :sortable="false"
              :filterable="false"
              label="Delete"
            >
              <template slot-scope="row">
                <input v-if="Object.keys(row).indexOf('delete') !== -1" v-model="row.delete" type="checkbox" >
              </template>
            </table-column>
            <table-column
              :sortable="false"
              :filterable="false"
              label="Print"
            >
              <template slot-scope="row">
                <input v-if="Object.keys(row).indexOf('print') !== -1" v-model="row.print" type="checkbox" >
              </template>
            </table-column>
          </table-component>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <button type="button" class="btn btn-primary" @click="goBack">Back</button>
          <button type="submit" class="btn btn-success">Create</button>
        </div>
      </div>
    </form>
    <div v-else class="card">
      <div class="card-header">
        <h3>You have not permission for do that</h3>
      </div>
    </div>
  </div>
</template>

<script>
/* global axios, toastr */
import { required, minLength } from 'vuelidate/lib/validators'
export default {
  name: 'TestimonialsCreate',
  data () {
    return {
      record: {
        matrix: {}
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    let route = '/api/admin/accounts/roles/getMatrix'
    axios
      .get(route)
      .then(repsonse => {
        next(vm => (vm.record.matrix = repsonse.data.matrix))
      })
      .catch(error => {
        console.log(error)
        next()
      })
  },
  // when route changes and this component is already rendered,
  // the logic will be slightly different.
  beforeRouteUpdate (to, from, next) {
    console.log('update')
  },
  validations: {
    record: {
      name: {
        required,
        minLength: minLength(4)
      }
    }
  },
  methods: {
    createRecord () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        axios
          .post('/api/admin/accounts/roles/save', {
            role: this.record
          })
          .then(response => {
            if (response && response.data && response.data.result === 'ok') {
              this.record = response.data.record
              toastr['success']('Role has been created successfully')
            } else {
              let message =
                (response && response.data && response.data.message) ||
                'Something goes wrong'
              toastr['error'](message)
            }
          })
          .catch(error => {
            let message = (error && error.message) || 'Something goes wrong'
            toastr['error'](message)
          })
      }
    },
    goBack () {
      this.$router.push('/admin/accounts/roles')
    }
  }
}
</script>

<style>
</style>
